import { render, staticRenderFns } from "./InitialLoader.vue?vue&type=template&id=53a63735"
import script from "./InitialLoader.vue?vue&type=script&lang=js"
export * from "./InitialLoader.vue?vue&type=script&lang=js"
import style0 from "./InitialLoader.vue?vue&type=style&index=0&id=53a63735&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports